import * as React from "react";
import { debounceAsync } from "../../";

type FunctionType<F, R> = (...args: F[]) => R;
export const useDebounce = <F, R, T extends FunctionType<F, R>>(
    callback: T,
    delayMilliseconds: number,
    dependencies: React.DependencyList
    // eslint-disable-next-line arrow-body-style
) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback(
        debounceAsync(callback, delayMilliseconds || 500),
        dependencies
    );
};
